
/*global */
import React, { Component } from 'react';

class DocsConsolidation extends Component {
    render() {
        return (
            <div className="mb-3">
                <h2>Consolidating parallel test runs</h2>
                <p>If you execute multiple test runs in parallel or serially for the same build or release and results are submitted to Tesults within each run, separately, you will find that multiple test runs are generated on Tesults. This is because the default behavior on Tesults is to treat each results submission as a separate test run. This behavior can be changed from the configuration menu. Click 'Results Consolidation By Build' from the Configure Project menu to enable and disable consolidation by target. Enabling consolidation will mean that multiple test runs submitted with the same build name will be consolidated into a single test run.</p>
            </div>
        );
    }
}

export default DocsConsolidation;